// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as RegulaminRouteImport } from './routes/regulamin'
import { Route as RealizacjeRouteImport } from './routes/realizacje'
import { Route as PolitykaPrywatnosciRouteImport } from './routes/polityka-prywatnosci'
import { Route as MarketingRouteImport } from './routes/marketing'
import { Route as CookiesRouteImport } from './routes/cookies'
import { Route as IndexRouteImport } from './routes/index'
import { Route as DemoIndexRouteImport } from './routes/demo.index'
import { Route as DemoElektrykRouteImport } from './routes/demo.elektryk'
import { Route as DemoBurzeStanicaRouteImport } from './routes/demo.burze-stanica'
import { Route as DemoElektrykRealizacjeRouteImport } from './routes/demo.elektryk_.realizacje'
import { Route as DemoElektrykAdminRouteImport } from './routes/demo.elektryk_.admin'

const RegulaminRoute = RegulaminRouteImport.update({
            id: '/regulamin',path: '/regulamin',getParentRoute: () => rootRouteImport
          })
const RealizacjeRoute = RealizacjeRouteImport.update({
            id: '/realizacje',path: '/realizacje',getParentRoute: () => rootRouteImport
          })
const PolitykaPrywatnosciRoute = PolitykaPrywatnosciRouteImport.update({
            id: '/polityka-prywatnosci',path: '/polityka-prywatnosci',getParentRoute: () => rootRouteImport
          })
const MarketingRoute = MarketingRouteImport.update({
            id: '/marketing',path: '/marketing',getParentRoute: () => rootRouteImport
          })
const CookiesRoute = CookiesRouteImport.update({
            id: '/cookies',path: '/cookies',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const DemoIndexRoute = DemoIndexRouteImport.update({
            id: '/demo/',path: '/demo/',getParentRoute: () => rootRouteImport
          })
const DemoElektrykRoute = DemoElektrykRouteImport.update({
            id: '/demo/elektryk',path: '/demo/elektryk',getParentRoute: () => rootRouteImport
          })
const DemoBurzeStanicaRoute = DemoBurzeStanicaRouteImport.update({
            id: '/demo/burze-stanica',path: '/demo/burze-stanica',getParentRoute: () => rootRouteImport
          })
const DemoElektrykRealizacjeRoute = DemoElektrykRealizacjeRouteImport.update({
            id: '/demo/elektryk_/realizacje',path: '/demo/elektryk/realizacje',getParentRoute: () => rootRouteImport
          })
const DemoElektrykAdminRoute = DemoElektrykAdminRouteImport.update({
            id: '/demo/elektryk_/admin',path: '/demo/elektryk/admin',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,CookiesRoute: CookiesRoute,MarketingRoute: MarketingRoute,PolitykaPrywatnosciRoute: PolitykaPrywatnosciRoute,RealizacjeRoute: RealizacjeRoute,RegulaminRoute: RegulaminRoute,DemoBurzeStanicaRoute: DemoBurzeStanicaRoute,DemoElektrykRoute: DemoElektrykRoute,DemoIndexRoute: DemoIndexRoute,DemoElektrykAdminRoute: DemoElektrykAdminRoute,DemoElektrykRealizacjeRoute: DemoElektrykRealizacjeRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)